import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'

import FooterNav from './FooterNav'
import FooterAvantLogo from './FooterAvantLogo'
import SocialsIcons from './Social/SocialsIcons'

class Footer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      year: 0
    }
  }

  componentDidMount() {
    const year = new Date().getFullYear()
    this.setState({ year })
  }

  render() {
    const { year } = this.state

    const {
      data: {
        allContentfulFooter: {
          edges: [
            {
              node: { logo, linkGroups, copyright, socialIcons }
            }
          ]
        }
      }
    } = this.props
    return (
      <footer className="footer">
        <div className="container__inner">
          <ul className="footer__list">
            <div className="footer__logo-box">
              <FooterAvantLogo imageLink={logo} />
            </div>
            <FooterNav linkGroups={linkGroups} />
          </ul>

          <div className="social">
            <div className="social__logo-box">
              <FooterAvantLogo imageLink={logo} />
            </div>

            <SocialsIcons imageLinks={socialIcons} />

            <p className="social__copywrite">{copyright.replace('{year}', year)}</p>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = {
  data: PropTypes.object.isRequired
}

export default function DefaultQuery() {
  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulFooter(filter: { contentful_id: { eq: "22s0IRBFFFHHxo79MlL5mn" } }) {
            edges {
              node {
                logo {
                  url
                  image {
                    title
                    file {
                      url
                    }
                  }
                }
                linkGroups {
                  title
                  links {
                    ... on ContentfulTextLink {
                      title
                      url
                    }
                  }
                }
                copyright
                socialIcons {
                  url
                  image {
                    title
                    file {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => <Footer data={data} />}
    />
  )
}
